<script>
import HeaderMixin from "../header-mixin";

export default {
    mixins: [HeaderMixin],

    data() {
        return {
            activeSubmenuID: null,
            isToggled: false,
            vOConfig: {
                handler: this.clickOutsideHandler,
                middleware: this.clickOutsideMiddleware
            }
        };
    },

    methods: {
        toggleMenu(menuId) {
            this.isToggled = true;
            if (this.activeDropdownID == menuId) {
                this.closeMenu();
            } else {
                this.activeDropdownID = menuId;
                Event.$emit("mobile-menu:open", true);
            }
        },

        clickOutsideHandler(e) {
            this.closeMenu();
        },

        closeMenu() {
            // Event.$emit("mobile-menu:open", false);
            this.activeDropdownID = null;
            this.activeSubmenuID = null;
            this.isToggled = false;
        },

        clickOutsideMiddleware(event) {
            return !event.target.classList.contains("toggle");
        },

        toggleMemberCompaniesMenu() {
            Event.$emit("hover-menu:open");
        }
    }
};
</script>
